import { MutationTree } from 'vuex'
import { AlertsConfigurationState } from '@/store/modules/alertsConfiguration/alertsConfigurationTypes'

export const mutations: MutationTree<AlertsConfigurationState> = {
  UPDATE_ALERTS_CONFIGURATION(state:AlertsConfigurationState, alertsConfiguration) {
    state.configuration = alertsConfiguration
  },
}
